import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { kycApi } from '../lib/api'
import { useIsOperator } from './FromAddress'

/**
 * Things waiting on the platform operator: identity-verification submissions to review.
 * Polled every minute for SuperAdmins only; customers never call the admin endpoint.
 */
export function useOperatorAlerts() {
  const operator = useIsOperator()
  const { data } = useQuery({
    queryKey: ['admin', 'kyc', 'submitted', 'alerts'],
    queryFn: () => kycApi.admin.list('submitted'),
    enabled: operator,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
    staleTime: 30_000,
  })
  const pending = operator ? (data?.data ?? []) : []
  return { operator, pending, count: pending.length }
}

/** Puts the waiting count in the browser tab title, e.g. "(1) ItsBingMyBusiness". */
export function useTitleCount(count: number) {
  useEffect(() => {
    const base = document.title.replace(/^\(\d+\)\s*/, '')
    document.title = count > 0 ? `(${count}) ${base}` : base
  }, [count])
}

/** Small count pill for sidebar links. */
export function NavCount({ n }: { n: number }) {
  if (n <= 0) return null
  return <span className="nav-count" aria-label={`${n} waiting`}>{n > 99 ? '99+' : n}</span>
}
